import { compare } from "./Util";
import FSymbol from "./Symbol";
export default class Comparer {
    constructor(f) {
        this.Compare = f || compare;
    }
    [FSymbol.reflection]() {
        return { interfaces: ["System.IComparer"] };
    }
}
export function fromEqualityComparer(comparer) {
    if (typeof comparer.Compare === "function") {
        return new Comparer(comparer.Compare);
    }
    else {
        return new Comparer(function (x, y) {
            var xhash = comparer.GetHashCode(x), yhash = comparer.GetHashCode(y);
            if (xhash === yhash) {
                return comparer.Equals(x, y) ? 0 : -1;
            }
            else {
                return xhash < yhash ? -1 : 1;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./packages/Fable.Elmish/fable/cmd.fs